import { getPatientByLocalId } from '../../store/idbHandler';
import { track } from '../../tracking';

export const getPatientAndRelationPatients = async (pid: string) => {
    try {
        const patient = await getPatientByLocalId(pid);
        if (!patient) {
            console.error('Patient not found');
            track('ERROR', { on: 'getPatientByLocalId' });
            return null;
        }
        const relations = Array.isArray(patient.relations) ? patient?.relations : [];
        const relationPatientIds = relations.map((i) => i.pid);
        const allRelationPatients = await Promise.all(
            relationPatientIds.map(async (l) => {
                return await getPatientByLocalId(l);
            }),
        );
        const relationPatients = allRelationPatients.filter(Boolean);
        return { patient, relationPatients };
    } catch (error) {
        console.error('Error fetching patient and relation patients', error);
        track('ERROR', { on: 'getPatientByLocalId', error: (error as Error).message });
        return null;
    }
};
